import React, { useEffect } from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import styles from './Notification.module.css';

const Notification = ({ 
  type = 'success', // 'success', 'error', 'warning', 'info'
  message, 
  onClose, 
  autoClose = true, 
  duration = 5000,
  position = 'top-right' // 'top-right', 'top-center', 'bottom-right', 'bottom-center'
}) => {
  useEffect(() => {
    if (autoClose && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className={styles.icon} />;
      case 'error':
        return <FaExclamationTriangle className={styles.icon} />;
      case 'warning':
        return <FaExclamationTriangle className={styles.icon} />;
      case 'info':
        return <FaInfoCircle className={styles.icon} />;
      default:
        return <FaCheckCircle className={styles.icon} />;
    }
  };

  const notificationClasses = `${styles.notification} ${styles[type]} ${styles[position]}`;

  return (
    <div className={notificationClasses}>
      {getIcon()}
      <span className={styles.message}>{message}</span>
      {onClose && (
        <button className={styles.closeButton} onClick={onClose} aria-label="Close notification">
          <FaTimes />
        </button>
      )}
    </div>
  );
};

export default Notification;

